import { render } from "./BaseLayout.vue?vue&type=template&id=2d1740c8&scoped=true"
import script from "./BaseLayout.vue?vue&type=script&lang=ts"
export * from "./BaseLayout.vue?vue&type=script&lang=ts"

import "./BaseLayout.vue?vue&type=style&index=0&id=2d1740c8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2d1740c8"

export default script